import { useMemo } from 'react';

import { PlatformConfiguration } from '@store:web/components/common/ShareSocialsList/utils';

interface HotOfferShareInfo {
  url: string;
  name: string;
  amount: string;
  currency: string;
}

export const useHotOfferShareConfig = ({
  url,
  name,
  amount,
  currency,
}: HotOfferShareInfo): PlatformConfiguration => {
  return useMemo(() => {
    const reward = amount + (currency !== '%' ? ` ${currency}` : currency);

    return {
      Reddit: {
        title: `Grab the ${name} from the Magic Store and Earn up to ${reward}!`,
        message:
          'Hey Reddit community,\n' +
          `I wanted to share a fantastic opportunity that's just cropped up. Magic Store has just launched their ${name}, and it's genuinely something to get excited about.\n` +
          `What's the deal? Well, you could earn up to ${reward} just by participating! It seems like a no-brainer to me.\n` +
          "Here's the link to get started: {{url}}\n" +
          "This is a limited-time offer, so make sure you don't miss out. I'd love to hear your thoughts on this!\n" +
          'Cheers\n',
        url,
      },
      Email: {
        title: `Amazing Opportunity: Earn ${reward} with the Magic Store's Hot Offer!`,
        message:
          '\n' +
          'Hey,\n' +
          "Hope you're doing well!\n" +
          `You know I'm always on the lookout for fantastic deals and I've just come across something I think you'll love. The Magic Store has just released a really exciting promotion called the ${name}.\n` +
          `What's really awesome is that you could earn up to ${reward}! Yep, you read that right! Isn't that just super exciting?\n` +
          `Here's where you can get started: {{url}}\n` +
          "Remember, this is a limited-time offer, so don't wait too long to check it out. And feel free to spread the word to anyone else who might be interested!\n" +
          'Catch up soon\n' +
          '\n' +
          "P.S. I can't wait to hear if you decide to go for it! Let's see who earns more, eh? ;)\n",
        url,
      },
      Twitter: {
        message: `🔥 Unveiling the ${name} from Magic Store! This is your chance to earn up to ${reward}! Don't let this opportunity slip away. Explore here 👉 {{url}}`,
        url,
      },
      Telegram: {
        message:
          'Hey there!\n' +
          `Guess what? Magic Store has rolled out their ${name} and it's looking amazing! The best part? You have the chance to earn up to ${reward}!\n` +
          "Here's the link: {{url}}\n" +
          "This offer won't last forever, so be sure to check it out soon. Happy earning!\n" +
          'Cheers\n',
        url,
      },
      WhatsApp: {
        message:
          'Hey there!\n' +
          `Just stumbled upon this exciting offer and thought you'd be interested. Magic Store has come up with a new promotion, the ${name}. You could earn up to ${reward}!\n` +
          "Here's the link to check it out: {{url}}\n" +
          "Don't let this fantastic opportunity slip away! Let me know what you think.\n" +
          'Take care\n',
        url,
      },
      Facebook: {
        url,
      },
      LinkedIn: {
        url,
      },
    };
  }, [url, amount, name, currency]);
};
